import { useSupabaseStore } from '../providers/supabaseStore';
import useWalletStore from '../providers/walletStore';

export const useReward = () => {
  const { supabase, recordDailyCheckIn } = useSupabaseStore();
  const { wallet } = useWalletStore();

  const claimDailyCheckIn = async () => {
    if (!wallet?.address) return false;

    try {
      // Try to record the check-in
      const checkInSuccess = await recordDailyCheckIn(wallet.address);
      if (!checkInSuccess) return false;

      // If check-in was successful, update points
      const { data: userData, error: fetchError } = await supabase
        .from('members')
        .select('points')
        .eq('wallet_address', wallet.address)
        .single();

      if (fetchError) throw fetchError;

      const currentPoints = userData?.points || 0;
      const newPoints = currentPoints + 50;

      // Update points in database
      const { error: updateError } = await supabase
        .from('members')
        .update({ points: newPoints })
        .eq('wallet_address', wallet.address);

      if (updateError) throw updateError;

      return true;
    } catch (error) {
      console.error('Error claiming daily check-in:', error);
      return false;
    }
  };

  return {
    claimDailyCheckIn
  };
};

export default useReward;
